const youtubeJpeg =
  /^https:\/\/i(?:\d)?\.ytimg\.com\/vi\/([^/]+)\/(maxresdefault|sddefault|hqdefault|mqdefault|default)\.jpg(?:\?.*)?$/

const webpThumbnail = (url: string) => {
  const match = url.match(youtubeJpeg)
  return match ? `https://i.ytimg.com/vi_webp/${match[1]}/${match[2]}.webp` : undefined
}

export const getYoutubeThumbnailCandidates = (videoId: string, thumbnail?: string) => {
  // Only use maxres when the API supplied it. Smaller/older videos may not
  // have that rendition. Keep the JPEG immediately after its WebP fallback.
  const urls = [
    thumbnail?.trim(),
    ...['sddefault', 'hqdefault', 'mqdefault', 'default'].map(
      (size) => `https://i.ytimg.com/vi/${videoId}/${size}.jpg`
    ),
  ].filter((url): url is string => Boolean(url))

  // The API-provided JPEG can exist without a matching WebP rendition.
  // Start with the supplied source instead of inventing a potentially dead URL.
  return [...new Set(urls.flatMap((url) => [url, webpThumbnail(url)]).filter((url): url is string => Boolean(url)))]
}

export const isMissingYoutubeThumbnail = (url: string, naturalWidth: number) =>
  /\/vi(?:_webp)?\/[^/]+\/(?:maxresdefault|sddefault|hqdefault|mqdefault)\./.test(url) && naturalWidth <= 120
